import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../Seo';
import { DISCOVERY_PAGES, VERIFIED_DATE, VERIFIED_DATE_LABEL, SETUP_REQUEST_URL, installUrl } from '../../data/discoveryPages';
import './DiscoveryLayout.css';

export function SourceLink({ href, children }) {
  return <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
}

export function Faq({ items }) {
  return (
    <section id="frequently-asked-questions" className="discovery-faq" aria-labelledby="discovery-faq-heading">
      <h2 id="discovery-faq-heading">Frequently asked questions</h2>
      {items.map(({ question, answer }) => (
        <div key={question}>
          <h3>{question}</h3>
          <p>{answer}</p>
        </div>
      ))}
    </section>
  );
}

export function SetupOffer() {
  return (
    <section id="free-first-campaign-setup" className="discovery-offer" aria-labelledby="discovery-offer-heading">
      <p className="discovery-eyebrow">A hand with your first launch</p>
      <h2 id="discovery-offer-heading">Free first-campaign setup, including on the Free plan</h2>
      <p>New Clean Sweeps subscribers can request one first-campaign setup per store. We help configure your campaign and place the standard entry widgets included in your selected plan.</p>
      <ul>
        <li>Campaign configuration using the entry rules and dates you provide.</li>
        <li>Placement and configuration of existing widgets available on your plan.</li>
        <li>A walkthrough of the configured entry rules and storefront displays.</li>
      </ul>
      <p>App subscription fees still apply to paid plans. This one-time offer excludes legal services, custom development, historical entry migration, and ongoing campaign management. It does not unlock features from higher plans. Diamond retains its broader white-glove setup and consultation services.</p>
      <p>Tell us your store URL, campaign goals, and planned launch date so we can arrange setup. No review is required.</p>
      <a className="discovery-button" href={SETUP_REQUEST_URL}>Request free first-campaign setup</a>
    </section>
  );
}

export default function DiscoveryLayout({ path, title, description, eyebrow, sections = [], children }) {
  return (
    <main className="discovery-page">
      <Seo title={DISCOVERY_PAGES.find(page => page.path === path)?.seoTitle || `${title} | Clean Sweeps`} description={description} path={path}
        image="/og/resources.png" imageAlt="Clean Sweeps sweepstakes guides" />
      <article className="discovery-article">
        <header className="discovery-hero">
          <p className="discovery-eyebrow">{eyebrow || 'Clean Sweeps guides'}</p>
          <h1>{title}</h1>
          <p className="discovery-lead">{description}</p>
          <p className="discovery-meta">By Clean Sweeps · Sources checked <time dateTime={VERIFIED_DATE}>{VERIFIED_DATE_LABEL}</time></p>
          <div className="discovery-actions">
            <a className="discovery-button" href={installUrl(path)}>Install Clean Sweeps</a>
            <a className="discovery-button discovery-button-secondary" href="#free-first-campaign-setup">Get free setup help</a>
          </div>
          <p className="discovery-disclosure">Published by Clean Sweeps, the Shopify sweepstakes app. Other companies are independent of Clean Sweeps; their inclusion does not imply affiliation, endorsement, or that they use our app. Sources describe the offerings or campaigns reviewed on the date above.</p>
        </header>
        {sections.length > 0 && (
          <nav className="discovery-toc" aria-label="On this page">
            <h2>On this page</h2>
            <ul>{sections.map(({ id, label }) => <li key={id}><a href={`#${id}`}>{label}</a></li>)}</ul>
          </nav>
        )}
        <div className="discovery-content">{children}</div>
        <SetupOffer />
        <nav className="discovery-related" aria-label="Related guides and comparisons">
          <h2>Keep exploring</h2>
          <ul>{DISCOVERY_PAGES.filter(page => page.path !== path).map(page => (
            <li key={page.path}><Link to={page.path}>{page.label}</Link></li>
          ))}</ul>
          <p><Link to="/setup">Clean Sweeps setup guides</Link> · <Link to="/#pricing">Plans and pricing</Link></p>
        </nav>
      </article>
    </main>
  );
}
